import { Text } from '../Text'
import { TimeInputProps } from './types'

export const TimeInput = ({
    onChangeCustom,
    t,
    hours,
    minutes,
}: TimeInputProps) => {
    const handleHoursChange = (value: string) => {
        const numValue = parseInt(value, 10)
        if (!isNaN(numValue) && numValue >= 0 && numValue <= 23) {
            onChangeCustom(numValue, parseInt(minutes) || 0)
        }
    }

    const handleMinutesChange = (value: string) => {
        const numValue = parseInt(value, 10)
        if (!isNaN(numValue) && numValue >= 0 && numValue <= 59) {
            onChangeCustom(parseInt(hours) || 0, numValue)
        }
    }

    return (
        <div className="flex w-[20rem] flex-col gap-2 rounded-b-lg bg-background-base px-4 py-2 align-middle">
            <Text text={t('shared:utils.time.title')} size="md" />
            <div className="flex items-center justify-center align-middle">
                <input
                    name="hours"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={2}
                    value={hours}
                    placeholder={'00'}
                    onChange={({ target: { value } }) =>
                        handleHoursChange(value)
                    }
                    className="max-w-32 rounded-full border border-border-light bg-background-base p-2 text-center font-sans text-xs font-bold leading-tight text-slate-400 outline-none"
                />
                <span className="mx-2 text-lg text-slate-400">:</span>
                <input
                    name="minutes"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={2}
                    value={minutes}
                    placeholder={'00'}
                    onChange={({ target: { value } }) =>
                        handleMinutesChange(value)
                    }
                    className="max-w-32 rounded-full border border-border-light bg-background-base p-2 text-center font-sans text-xs font-bold leading-tight text-slate-400 outline-none"
                />
            </div>
        </div>
    )
}
